define(["require", "exports", "./querystring", "./url"], function (require, exports, querystring_1, url_1) {
    "use strict";
    exports.__esModule = true;
    function gotoFullCustomization(styleIndex, customizeUrl) {
        var query = (customizeUrl ? url_1.parseUrl(customizeUrl) : { query: { cp: 1 } }).query;
        var curQuery = url_1.parseUrl(window.location.href).query;
        var hasSize = curQuery && curQuery.w || query && query.w;
        var combined = $.extend(query || {}, curQuery || {}, { s: styleIndex, uc: hasSize ? 1 : 0, cp: 3 });
        if (styleIndex >= 0) {
            window.location.href = "/catalog/customize" + querystring_1.formatQuery(combined);
        }
        else {
            window.location.href = '/catalog/customize';
        }
    }
    exports.gotoFullCustomization = gotoFullCustomization;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/advancedCustomize.js
// module id = 87
// module chunks = 0